export enum FormFilterType {
  SEARCH_TERM = 'searchTerm',
  TAKEPAYMENT = 'takePayment',
  DRAFT_PUBLISHED_STATUS = 'Draft/Published Status',
  ARCHIVE_STATUS = 'archiveStatus',
}
